import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import Button from '../../Button';

const Exists = props => (
  <fieldset className="justifycentre existing-section">
    <Heading classes="header-text smaller purple" center>This account already exists</Heading>
    <Paragraph classes="width-limited" center>An account already exists with this email and date of birth.</Paragraph>
    <Paragraph classes="width-limited" center>If you don't remember your password you can <a href="/forgot-password">reset it here</a>.</Paragraph>
    <Paragraph classes="width-limited" center>Otherwise, you can <a href="/login">login here</a>.</Paragraph>
    <Paragraph classes="button-groups divideline" center>
      <Button classes={['underline-button']} label="Back" onClick={props.previousPage} />
    </Paragraph>
  </fieldset>
);

Exists.propTypes = {
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registrationPilot', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Exists);



// WEBPACK FOOTER //
// ./src/Components/PilotRegister/FormPages/Exists.jsx